import { useEffect, useState } from "react";
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { getGalleryInner } from "../Service/Api";
import LazyLoad from "react-lazyload";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

const Gallery = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState();
  const [selectedMonth, setSelectedMonth] = useState("All");
  const [monthOptions, setMonthOptions] = useState(["All"]);
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear}`;
    setSelectedYear(Year);
  }, []);

  const convertDateToDDMMYYYY = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      const galleryData1 = await getGalleryInner();
      const galleryData = galleryData1.filter(
        (item) =>
          item.school === "FARRUKHABAD" && item.category === "PhotoGallery",
      );

      // Convert date to DD MM YYYY format
      const formattedGalleryData = galleryData.map((item) => ({
        ...item,
        formattedDate: item.date ? convertDateToDDMMYYYY(item.date) : null,
      }));

      setData(formattedGalleryData);

      const yearsSet = new Set();
      const monthsSet = new Set();

      formattedGalleryData.forEach((item) => {
        if (item.date) {
          const date = new Date(item.date);
          yearsSet.add(date.getFullYear());
          monthsSet.add(date.getMonth());
        }
      });

      const uniqueYearRanges = Array.from(yearsSet).sort((a, b) => b - a);
      setYearRanges(uniqueYearRanges);

      const monthOptions = Array.from(monthsSet)
        .sort((a, b) => a - b)
        .map((month) => monthNames[month]);
      setMonthOptions(["All", ...monthOptions]);
    };

    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;

    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const date = new Date(itemDate);
          const year = date.getFullYear();
          const month = date.getMonth();
          return (
            year === parseInt(selectedYear) &&
            (selectedMonth === "All" || monthNames[month] === selectedMonth)
          );
        }
        return false;
      });
    } else if (selectedMonth !== "All") {
      filteredData = filteredData.filter((item) => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const month = new Date(itemDate).getMonth();
          return monthNames[month] === selectedMonth;
        }
        return false;
      });
    }

    // Fallback to the previous year if no data is found
    if (filteredData.length === 0 && selectedYear !== "All") {
      const previousYear = parseInt(selectedYear) - 1; // Calculate fallback year
      const fallbackData = data.filter((item) => {
        const itemDate = item.date?.trim();
        if (itemDate) {
          const year = new Date(itemDate).getFullYear();
          return year === previousYear;
        }
        return false;
      });

      if (fallbackData.length > 0) {
        setSelectedYear(previousYear.toString()); // Update the selected year to fallback
        filteredData = fallbackData; // Use fallback data
      }
    }

    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    // Sort the filtered data by date in descending order
    filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

    setFilteredData(filteredData);
  }, [selectedYear, selectedMonth, searchQuery, data]);

  const handleModal = (id) => {
    navigate(`/SubGallery?id=${id}`);
  };

  const emptyArray = [
    {
      description: "Stay Tuned for Latest Updates",
      attachments: ["placeholder.jpg"],
    },
  ];

  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Photo Gallery</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li>Gallery</li>
            <li>|</li>
            <li>Photo Gallery</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row tabs-dynamic">
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="count-val">
                <p>Total Categories: {filterData.length}</p>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  className="yearSelection"
                >
                  <option value="All">All</option>
                  {yearRanges.map((yr) => (
                    <option key={yr} value={yr}>
                      {yr}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="month-selection">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className="monthSelect"
                >
                  {monthOptions.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-6 col-12">
              <div className="searchBox">
                <input
                  type="text"
                  id="myInput"
                  name="name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search Here.."
                />
              </div>
            </div>
          </div>
          <div className="row years showYear">
            {filterData.length > 0
              ? filterData.map((item, index) => (
                  <div
                    className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-12 galleryCount"
                    key={index}
                  >
                    <div className="gal_new">
                      <article>
                        <LazyLoad>
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments[0]}`}
                            alt="Gallery"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <div className="gal-content">
                          <h4 className="catgry-name">{item.title}</h4>
                          <p>{item.description}</p>
                          {item.url && (
                            <Link to={item.url}>Download Photos</Link>
                          )}
                          <p className="date">
                            <i>
                              <i className="bi bi-calendar-week"></i>{" "}
                              {item.formattedDate}
                            </i>
                            <span>
                              <a onClick={() => handleModal(item._id)}>
                                View More <i className="bi bi-arrow-right"></i>
                              </a>
                            </span>
                          </p>
                          <div className="total-img">
                            <i className="bi bi-card-image"></i>
                            <p>{item?.attachments.length}</p>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                ))
              : emptyArray.map((data, index) => (
                  <div
                    key={index}
                    className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-12 galleryCount"
                  >
                    <div className="gal_new">
                      <article>
                        <LazyLoad>
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/gallery1.jpg"
                            alt="Gallery Placeholder"
                            className="img-fluid"
                          />
                        </LazyLoad>
                        <div className="gal-content">
                          <h4 className="catgry-name">Category Name</h4>
                          <p>Stay Tuned for Latest Updates</p>
                          <p className="date">
                            <i>
                              <i className="bi bi-calendar-week"></i> DD MM YYYY
                            </i>
                            <span>
                              <Link to="/">
                                View More <i className="bi bi-arrow-right"></i>
                              </Link>
                            </span>
                          </p>
                          <div className="total-img">
                            <i className="bi bi-card-image"></i>
                            <p>5</p>
                          </div>
                        </div>
                      </article>
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Gallery;
